module.exports = __webpack_public_path__ + "img/3.a2033796.png";